import Accordion from './Accordion'
import type { AccordionTabProps } from './Accordion.types'

export { AccordionTabProps }
export default Accordion
